"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelegatedPermissionsClient = void 0;
const baseAuthApi_1 = require("../../baseAuthApi");
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class DelegatedPermissionsClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async createPermissionInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions', {
            path: {},
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async createPermissionComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/permissions', {
            path: {},
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async updatePermissionInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async updatePermissionComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async archivePermissionInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async archivePermissionComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId/archive', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getPermissionById(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/:permissionId', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPermissions() {
        const path = (0, url_1.buildPathAndQuery)('/permissions', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createPermissionPredicateInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async createPermissionPredicateComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async updatePermissionPredicateInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates/:predicateId', {
            path: {
                permissionId: request.permissionId,
                predicateId: request.predicateId,
            },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async updatePermissionPredicateComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates/:predicateId', {
            path: {
                permissionId: request.permissionId,
                predicateId: request.predicateId,
            },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async archivePermissionPredicateInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates/:predicateId/archive', {
            path: {
                permissionId: request.permissionId,
                predicateId: request.predicateId,
            },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'PUT',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async archivePermissionPredicateComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates/:predicateId/archive', {
            path: {
                permissionId: request.permissionId,
                predicateId: request.predicateId,
            },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'PUT',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPermissionPredicates(request) {
        const path = (0, url_1.buildPathAndQuery)('/dev-permissions/:permissionId/predicates', {
            path: { permissionId: request.permissionId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createPermissionAssignmentInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments', {
            path: {},
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'POST',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify(request.body),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async createPermissionAssignmentComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments', {
            path: {},
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'POST',
            body: request.body,
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async revokePermissionAssignmentInit(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments/:assignmentId', {
            path: { assignmentId: request.assignmentId },
            query: {},
        });
        const challenge = await baseAuthApi_1.BaseAuthApi.createUserActionChallenge({
            userActionHttpMethod: 'DELETE',
            userActionHttpPath: path,
            userActionPayload: JSON.stringify({}),
            userActionServerKind: 'Api',
        }, this.apiOptions);
        return challenge;
    }
    async revokePermissionAssignmentComplete(request, signedChallenge) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments/:assignmentId', {
            path: { assignmentId: request.assignmentId },
            query: {},
        });
        const { userAction } = await baseAuthApi_1.BaseAuthApi.signUserActionChallenge(signedChallenge, this.apiOptions);
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'DELETE',
            body: {},
            headers: { 'x-dfns-useraction': userAction },
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPermissionAssignments(request) {
        const path = (0, url_1.buildPathAndQuery)('/permissions/assignments', {
            path: {},
            query: request.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.DelegatedPermissionsClient = DelegatedPermissionsClient;
